/**
 * Titles are mandatory, and unique among the articles and news of one
 * Mandant (the server checks, ArticlesService.titleClash). These turn the two
 * refusals into what the title field shows.
 */

/** The message for a title that is empty, or null when there is one. */
export function missingTitleMessage(title, t) {
  return title.trim() ? null : t('articleTitle.required');
}

/** The message for a server refusal of the title, or null for any other error. */
export function titleErrorMessage(error, title, t) {
  if (error?.status === 409 && error?.data?.code === 'TITLE_TAKEN') {
    const { department } = error.data;
    return department
      ? t('articleTitle.taken', { title: title.trim(), department })
      : t('articleTitle.takenNoDepartment', { title: title.trim() });
  }

  const messages = [].concat(error?.data?.message ?? []);
  if (error?.status === 400 && messages.includes('title must not be empty')) {
    return t('articleTitle.required');
  }

  return null;
}
